import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import SingleSelectForm from "./SingleSelectForm";
function SchemeForm(_ref) {
  var _gradingSchemeId$toSt;
  var id = _ref.id,
    formValidated = _ref.formValidated,
    gradingSchemes = _ref.gradingSchemes,
    gradingSchemeId = _ref.gradingSchemeId,
    onSubmit = _ref.onSubmit;
  var options = React.useMemo(function () {
    return gradingSchemes.map(function (scheme) {
      return {
        label: scheme.name,
        value: scheme.id.toString()
      };
    });
  }, [gradingSchemes]);
  return /*#__PURE__*/React.createElement(SingleSelectForm, {
    defaultValue: (_gradingSchemeId$toSt = gradingSchemeId === null || gradingSchemeId === void 0 ? void 0 : gradingSchemeId.toString()) !== null && _gradingSchemeId$toSt !== void 0 ? _gradingSchemeId$toSt : null,
    formValidated: formValidated,
    id: id,
    label: "Grading scheme",
    options: options,
    onSubmit: onSubmit
  });
}
export default SchemeForm;